module.exports = __webpack_public_path__ + "img/movil4.220c8bc8.jpg";